import React from 'react'
import { formatedDate } from '../../../utils/formatedDate'
import styled from 'styled-components'
import { StyledCard } from '../../Cards/StyledCard'
import { useTranslation } from 'react-i18next'

const StyledMetaInfoBlock = styled(StyledCard)`
  font-size: 14px;
`

const StyledInfoItemsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const StyledInfoItem = styled.div`
  padding: 15px 25px;
  width: 200px;
`

const StyledMetaLabel = styled.div`
  font-weight: bold;
`
export default function MetaInfoBlock({headerData}) {
    const { t } = useTranslation()
    if (!headerData) {
      return null
    }
    return (
        <StyledMetaInfoBlock>
            <StyledInfoItemsContainer>
            <div className='d-flex justify-content-between flex-wrap'>
                <div>
                <StyledInfoItem>
                    <StyledMetaLabel>{t('returnsTable:receiptNo')}:</StyledMetaLabel>
                    <div>{headerData.number}</div>
                </StyledInfoItem>
                </div>
                <div>
                <StyledInfoItem>
                    <StyledMetaLabel>{t('OrderSubheader:costcenter')}:</StyledMetaLabel>
                    <div>{headerData.costcenter ? headerData.costcenter.displayName : null}</div>
                </StyledInfoItem>
                </div>
                <div>
                <StyledInfoItem>
                    <StyledMetaLabel>{t('OrderSubheader:orgaUnit')}:</StyledMetaLabel>
                    <div>{headerData.office ? headerData.office.displayName : null}</div>
                </StyledInfoItem>
                </div>
                {!!headerData.customer && (
                  <div>
                  <StyledInfoItem>
                      <StyledMetaLabel>{t('returnsTable:customer')}:</StyledMetaLabel>
                      <div>{headerData.customer ? headerData.customer.displayName : null}</div>
                  </StyledInfoItem>
                  </div>
                )}
                {!!headerData.order && (
                <div>
                <StyledInfoItem>
                    <StyledMetaLabel>{t('returnsTable:orderNo')}:</StyledMetaLabel>
                    <div>{headerData.order ? headerData.order.orderNr : null}</div>
                </StyledInfoItem>
                </div> 
                )}
                <div className='d-flex justify-content-between flex-grow-1'>
                  <StyledInfoItem>
                        <StyledMetaLabel>{t('returnsTable:expectedTimeOfArrival')}:</StyledMetaLabel>
                        <div>{formatedDate(headerData.expectedTimeOfArrival) ? formatedDate(headerData.expectedTimeOfArrival) : null}</div>
                  </StyledInfoItem>
                </div>
            </div>
            </StyledInfoItemsContainer>
        </StyledMetaInfoBlock>
    )
}